<template>
    <div class="row">
        <div class="col-12">
            <form class="form-inline">
                <div class="form-group">
                    <label class="col-form-label" for="naam">Naam&nbsp;&nbsp;&nbsp;</label>
                    <input @keyup="retrieveData" type="text" autocomplete="off" class="form-control" v-model="currentFilter.zoekstring" id="naam" name="naam" />
                </div>
            </form>
        </div><!--/.col-->
    </div><!--/.row-->
</template>

<script>
    export default {
        name: 'FilterForm',
        props: ['typeusers', 'currentFilter', 'get-items'],

        methods: {
            retrieveData () {
                this.$emit('get-items');
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/pages/bedrijf/FilterForm.vue